<script>
export default {
    name: 'IconDownload'
}
</script>
<template>
    <svg
        class="base-icon icon-download"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M52 52H12v4h40v-4zm-9.93-31.752L47 25.121 32 40 17 25.12l4.93-4.872 6.552 6.497V8h7.037v18.745l6.55-6.497z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
